"use strict";

var _toConsumableArray = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _defineProperty = require("/Users/satoshi/Documents/botlogy/projects/Ikitsuke-clinic/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_fsa_reducers_1 = require("typescript-fsa-reducers");

var scenario_state_1 = require("./scenario.state");

var scenario_actions_1 = __importDefault(require("./scenario.actions"));

var scenario_utils_1 = require("./scenario.utils");

var common_utils_1 = require("../../utils/common.utils");

var scenario_template_utils_1 = require("../../components/template-checkbox-tree/scenario-template.utils");
/*=====================================
    ACTION HANDLER
======================================*/

/* ScenarioNode
=====================================*/


exports.addNewNode = function (nodeMap, _ref) {
  var header = _ref.header,
      parentId = _ref.parentId,
      type = _ref.type,
      optionIndex = _ref.optionIndex;
  if (!scenario_utils_1.existNodeAndOption(nodeMap, parentId, optionIndex)) return nodeMap;
  var newNodeId = common_utils_1.generateRandomId(20);
  var newNode = scenario_utils_1.initNode(header, parentId, type);

  var newNodeAddedMap = _objectSpread({}, nodeMap, _defineProperty({}, newNodeId, newNode));

  var updateParentNode = scenario_utils_1.handleUpdateNode(parentId, scenario_utils_1.handleUpdateOptions(scenario_utils_1.handleUpdateOption(optionIndex, scenario_utils_1.handleSetActionId(newNodeId))));
  return updateParentNode(newNodeAddedMap);
};

exports.setActionUrl = function (nodeMap, _ref2) {
  var nodeId = _ref2.nodeId,
      optionIndex = _ref2.optionIndex,
      url = _ref2.url;
  if (!scenario_utils_1.existNodeAndOption(nodeMap, nodeId, optionIndex)) return nodeMap;
  var updateNode = scenario_utils_1.handleUpdateNode(nodeId, scenario_utils_1.handleUpdateOptions(scenario_utils_1.handleUpdateOption(optionIndex, scenario_utils_1.handleSetActionUrl(url))));
  return updateNode(nodeMap);
};

exports.removeActionUrl = function (nodeMap, _ref3) {
  var nodeId = _ref3.nodeId,
      optionIndex = _ref3.optionIndex;
  if (!scenario_utils_1.existNodeAndOption(nodeMap, nodeId, optionIndex)) return nodeMap;
  var updateNode = scenario_utils_1.handleUpdateNode(nodeId, scenario_utils_1.handleUpdateOptions(scenario_utils_1.handleUpdateOption(optionIndex, scenario_utils_1.handleResetActionType())));
  return updateNode(nodeMap);
};

exports.handleAddOption = function (nodeId, option) {
  return scenario_utils_1.handleUpdateNode(nodeId, scenario_utils_1.handleUpdateOptions(scenario_utils_1.handlePushOption(option)));
};

exports.addTextOption = function (nodeMap, _ref4) {
  var nodeId = _ref4.nodeId,
      label = _ref4.label;
  if (!scenario_utils_1.verifyNodeType(nodeMap, nodeId, scenario_state_1.ScenarioNodeType.Text)) return nodeMap;
  var updateNode = exports.handleAddOption(nodeId, scenario_utils_1.initTextOption(label));
  return updateNode(nodeMap);
};

exports.addImageOption = function (nodeMap, _ref5) {
  var nodeId = _ref5.nodeId,
      imageName = _ref5.imageName,
      imageUrl = _ref5.imageUrl;
  if (!scenario_utils_1.verifyNodeType(nodeMap, nodeId, scenario_state_1.ScenarioNodeType.Image)) return nodeMap;
  var updateNode = exports.handleAddOption(nodeId, scenario_utils_1.initImageOption(imageName, imageUrl));
  return updateNode(nodeMap);
};

exports.addImageExplanationOption = function (nodeMap, _ref6) {
  var nodeId = _ref6.nodeId,
      imageName = _ref6.imageName,
      imageUrl = _ref6.imageUrl,
      explanation = _ref6.explanation;
  if (!scenario_utils_1.verifyNodeType(nodeMap, nodeId, scenario_state_1.ScenarioNodeType.ImageExplanation)) return nodeMap;
  var updateNode = exports.handleAddOption(nodeId, scenario_utils_1.initImageExplanationOption(imageName, imageUrl, explanation));
  return updateNode(nodeMap);
};

exports.updateHeader = function (nodeMap, _ref7) {
  var nodeId = _ref7.nodeId,
      header = _ref7.header;
  if (!scenario_utils_1.existNode(nodeMap, nodeId)) return nodeMap;
  var updateNode = scenario_utils_1.handleUpdateNode(nodeId, scenario_utils_1.handleSetHeader(header));
  return updateNode(nodeMap);
};

exports.updateLabel = function (nodeMap, _ref8) {
  var nodeId = _ref8.nodeId,
      optionIndex = _ref8.optionIndex,
      label = _ref8.label;
  var isValid = scenario_utils_1.existNodeAndOption(nodeMap, nodeId, optionIndex) && scenario_utils_1.verifyNodeType(nodeMap, nodeId, scenario_state_1.ScenarioNodeType.Text);
  if (!isValid) return nodeMap;
  var updateNode = scenario_utils_1.handleUpdateNode(nodeId, scenario_utils_1.handleUpdateOptions(scenario_utils_1.handleUpdateOption(optionIndex, scenario_utils_1.handleSetLabel(label))));
  return updateNode(nodeMap);
}; //TODO updateImageName, updateImageName は重複が多いので共通化


exports.updateImageName = function (nodeMap, _ref9) {
  var nodeId = _ref9.nodeId,
      optionIndex = _ref9.optionIndex,
      imageName = _ref9.imageName;
  if (!scenario_utils_1.existNodeAndOption(nodeMap, nodeId, optionIndex)) return nodeMap;
  var isValidType = scenario_utils_1.verifyNodeType(nodeMap, nodeId, scenario_state_1.ScenarioNodeType.Image) || scenario_utils_1.verifyNodeType(nodeMap, nodeId, scenario_state_1.ScenarioNodeType.ImageExplanation);
  if (!isValidType) return nodeMap;
  var updateNode = scenario_utils_1.handleUpdateNode(nodeId, scenario_utils_1.handleUpdateOptions(scenario_utils_1.handleUpdateOption(optionIndex, scenario_utils_1.handleSetImageName(imageName))));
  return updateNode(nodeMap);
}; //TODO updateImageName, updateImageName は重複が多いので共通化


exports.updateImageUrl = function (nodeMap, _ref10) {
  var nodeId = _ref10.nodeId,
      optionIndex = _ref10.optionIndex,
      imageUrl = _ref10.imageUrl;
  if (!scenario_utils_1.existNodeAndOption(nodeMap, nodeId, optionIndex)) return nodeMap;
  var isValidType = scenario_utils_1.verifyNodeType(nodeMap, nodeId, scenario_state_1.ScenarioNodeType.Image) || scenario_utils_1.verifyNodeType(nodeMap, nodeId, scenario_state_1.ScenarioNodeType.ImageExplanation);
  if (!isValidType) return nodeMap;
  var updateNode = scenario_utils_1.handleUpdateNode(nodeId, scenario_utils_1.handleUpdateOptions(scenario_utils_1.handleUpdateOption(optionIndex, scenario_utils_1.handleSetImageUrl(imageUrl))));
  return updateNode(nodeMap);
}; //TODO updateImageName, updateImageName, updateExplanation は重複が多いので共通化


exports.updateExplanation = function (nodeMap, _ref11) {
  var nodeId = _ref11.nodeId,
      optionIndex = _ref11.optionIndex,
      explanation = _ref11.explanation;
  if (!scenario_utils_1.existNodeAndOption(nodeMap, nodeId, optionIndex)) return nodeMap;
  var isValidType = scenario_utils_1.verifyNodeType(nodeMap, nodeId, scenario_state_1.ScenarioNodeType.ImageExplanation);
  if (!isValidType) return nodeMap;
  var updateNode = scenario_utils_1.handleUpdateNode(nodeId, scenario_utils_1.handleUpdateOptions(scenario_utils_1.handleUpdateOption(optionIndex, scenario_utils_1.handleSetExplanation(explanation))));
  return updateNode(nodeMap);
};

exports.removeNode = function (nodeMap, _ref12) {
  var nodeId = _ref12.nodeId;
  var node = nodeMap[nodeId];
  if (!node) return nodeMap;
  var nodeMapHandlers = [scenario_utils_1.handleRemoveNode(nodeId)];
  var parentId = node.parentId;

  if (parentId && scenario_utils_1.existNode(nodeMap, parentId)) {
    var optionIndex = scenario_utils_1.findParentOptionIndex(nodeMap, nodeId, parentId);
    var resetParentNode = scenario_utils_1.handleUpdateNode(parentId, scenario_utils_1.handleUpdateOptions(scenario_utils_1.handleUpdateOption(optionIndex, scenario_utils_1.handleResetActionType())));
    nodeMapHandlers.push(resetParentNode);
  }

  return scenario_utils_1.pipeNodeMap.apply(scenario_utils_1, nodeMapHandlers)(nodeMap);
};

exports.removeOption = function (nodeMap, _ref13) {
  var nodeId = _ref13.nodeId,
      optionIndex = _ref13.optionIndex;
  if (!scenario_utils_1.existNodeAndOption(nodeMap, nodeId, optionIndex)) return nodeMap;
  var updateNode = scenario_utils_1.handleUpdateNode(nodeId, scenario_utils_1.handleUpdateOptions(scenario_utils_1.handleRemoveOption(optionIndex)));
  return updateNode(nodeMap);
};

exports.moveOption = function (nodeMap, _ref14) {
  var nodeId = _ref14.nodeId,
      fromIndex = _ref14.fromIndex,
      toIndex = _ref14.toIndex;
  var node = nodeMap[nodeId];
  if (!node) return nodeMap;
  if (fromIndex === toIndex) return nodeMap;
  if (!scenario_utils_1.existOption(node, fromIndex) || !scenario_utils_1.existOption(node, toIndex)) return nodeMap;
  var updateNode = scenario_utils_1.handleUpdateNode(nodeId, scenario_utils_1.handleUpdateOptions(scenario_utils_1.handleMoveOption(fromIndex, toIndex)));
  return updateNode(nodeMap);
};

exports.insertTemplate = function (nodeMap, _ref15) {
  var parentNodeId = _ref15.parentNodeId,
      parentOptionIndex = _ref15.parentOptionIndex,
      template = _ref15.template,
      templateTopNodeId = _ref15.templateTopNodeId;
  if (!scenario_utils_1.existNodeAndOption(nodeMap, parentNodeId, parentOptionIndex)) return nodeMap;
  if (!scenario_utils_1.existNode(template, templateTopNodeId)) return nodeMap;
  var newTopNodeId = common_utils_1.generateRandomId(20);
  var replacedTemplate = scenario_template_utils_1.replaceTopNodeId(template, templateTopNodeId, newTopNodeId);
  var mergeTemplate = scenario_utils_1.handleMergeNodeMap(replacedTemplate);
  var setParentIdOfInsertedNode = scenario_utils_1.handleUpdateNode(newTopNodeId, scenario_utils_1.handleSetParentId(parentNodeId));
  var setActionIdOfOptionInParentNode = scenario_utils_1.handleUpdateNode(parentNodeId, scenario_utils_1.handleUpdateOptions(scenario_utils_1.handleUpdateOption(parentOptionIndex, scenario_utils_1.handleSetActionId(newTopNodeId))));
  return scenario_utils_1.pipeNodeMap(mergeTemplate, setParentIdOfInsertedNode, setActionIdOfOptionInParentNode)(nodeMap);
};
/* Keyword
=====================================*/


exports.addKeyword = function (keywordsMap, _ref16) {
  var nodeId = _ref16.nodeId,
      keyword = _ref16.keyword;
  if (keyword === '') return keywordsMap;

  var clone = _objectSpread({}, keywordsMap);

  var keywords = clone[nodeId];
  clone[nodeId] = keywords ? [].concat(_toConsumableArray(keywords), [keyword]) : [keyword];
  return clone;
};

exports.removeKeyword = function (keywordsMap, _ref17) {
  var nodeId = _ref17.nodeId,
      keyword = _ref17.keyword;
  if (keyword === '') return keywordsMap;
  var keywords = keywordsMap[nodeId];
  if (!keywords || !keywords.length) return keywordsMap;

  var clone = _objectSpread({}, keywordsMap);

  clone[nodeId] = keywords.filter(function (k) {
    return k !== keyword;
  });
  return clone;
};
/*=====================================
    REDUCER
======================================*/


var scenarioReducer = typescript_fsa_reducers_1.reducerWithInitialState(scenario_state_1.INITIAL_SCENARIO_STATE)
/* Scenario
=====================================*/
.case(scenario_actions_1.default.initScenarioState, function (state, initialState) {
  return _objectSpread({}, state, {}, initialState);
}).case(scenario_actions_1.default.setCurrentNodeId, function (state, currentNodeId) {
  return _objectSpread({}, state, {
    currentNodeId: currentNodeId
  });
}).case(scenario_actions_1.default.setPreviewAction, function (state, previewAction) {
  return _objectSpread({}, state, {
    previewAction: previewAction
  });
})
/* ScenarioNode
=====================================*/
.case(scenario_actions_1.default.setNodeMap, function (state, nodeMap) {
  return _objectSpread({}, state, {
    nodeMap: nodeMap
  });
}).case(scenario_actions_1.default.createNode, function (state, paylaod) {
  return _objectSpread({}, state, {
    nodeMap: exports.addNewNode(state.nodeMap, paylaod)
  });
}).case(scenario_actions_1.default.setActionUrl, function (state, payload) {
  return _objectSpread({}, state, {
    nodeMap: exports.setActionUrl(state.nodeMap, payload)
  });
}).case(scenario_actions_1.default.removeActionUrl, function (state, payload) {
  return _objectSpread({}, state, {
    nodeMap: exports.removeActionUrl(state.nodeMap, payload)
  });
}).case(scenario_actions_1.default.addTextOption, function (state, payload) {
  return _objectSpread({}, state, {
    nodeMap: exports.addTextOption(state.nodeMap, payload)
  });
}).case(scenario_actions_1.default.addImageOption, function (state, payload) {
  return _objectSpread({}, state, {
    nodeMap: exports.addImageOption(state.nodeMap, payload)
  });
}).case(scenario_actions_1.default.addImageExplanationOption, function (state, payload) {
  return _objectSpread({}, state, {
    nodeMap: exports.addImageExplanationOption(state.nodeMap, payload)
  });
}).case(scenario_actions_1.default.updateHeader, function (state, payload) {
  return _objectSpread({}, state, {
    nodeMap: exports.updateHeader(state.nodeMap, payload)
  });
}).case(scenario_actions_1.default.updateLabel, function (state, payload) {
  return _objectSpread({}, state, {
    nodeMap: exports.updateLabel(state.nodeMap, payload)
  });
}).case(scenario_actions_1.default.updateImageName, function (state, payload) {
  return _objectSpread({}, state, {
    nodeMap: exports.updateImageName(state.nodeMap, payload)
  });
}).case(scenario_actions_1.default.updateImageUrl, function (state, payload) {
  return _objectSpread({}, state, {
    nodeMap: exports.updateImageUrl(state.nodeMap, payload)
  });
}).case(scenario_actions_1.default.updateExplanation, function (state, payload) {
  return _objectSpread({}, state, {
    nodeMap: exports.updateExplanation(state.nodeMap, payload)
  });
}).case(scenario_actions_1.default.moveNode, function (state, _ref18) {
  var nextNodeId = _ref18.nextNodeId;
  return _objectSpread({}, state, {
    currentNodeId: nextNodeId
  });
}).case(scenario_actions_1.default.removeNode, function (state, payload) {
  return _objectSpread({}, state, {
    nodeMap: exports.removeNode(state.nodeMap, payload)
  });
}).case(scenario_actions_1.default.removeCurrentNode, function (state) {
  var nodeMap = state.nodeMap,
      currentNodeId = state.currentNodeId;
  var currentNode = nodeMap[currentNodeId];
  if (!currentNode.parentId) return state;
  return _objectSpread({}, state, {
    nodeMap: exports.removeNode(state.nodeMap, {
      nodeId: state.currentNodeId
    }),
    currentNodeId: currentNode.parentId
  });
}).case(scenario_actions_1.default.removeOption, function (state, payload) {
  return _objectSpread({}, state, {
    nodeMap: exports.removeOption(state.nodeMap, payload)
  });
}).case(scenario_actions_1.default.moveOption, function (state, payload) {
  return _objectSpread({}, state, {
    nodeMap: exports.moveOption(state.nodeMap, payload)
  });
}).case(scenario_actions_1.default.insertTempalte, function (state, payload) {
  return _objectSpread({}, state, {
    nodeMap: exports.insertTemplate(state.nodeMap, payload)
  });
})
/* Keyword
=====================================*/
.case(scenario_actions_1.default.addKeyword, function (state, payload) {
  return _objectSpread({}, state, {
    keywordsMap: exports.addKeyword(state.keywordsMap, payload)
  });
}).case(scenario_actions_1.default.removeKeyword, function (state, payload) {
  return _objectSpread({}, state, {
    keywordsMap: exports.removeKeyword(state.keywordsMap, payload)
  });
})
/* Variable
=====================================*/
.case(scenario_actions_1.default.setScenarioDesign, function (state, design) {
  return _objectSpread({}, state, {
    design: design
  });
})
/* Design
=====================================*/
.case(scenario_actions_1.default.setVariables, function (state, variables) {
  return _objectSpread({}, state, {
    variables: variables
  });
});
exports.default = scenarioReducer;